import { render, staticRenderFns } from "./knowledgeOne.vue?vue&type=template&id=2638a9b2&scoped=true&"
import script from "./knowledgeOne.vue?vue&type=script&lang=js&"
export * from "./knowledgeOne.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeOne.vue?vue&type=style&index=0&id=2638a9b2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638a9b2",
  null
  
)

export default component.exports